import { useState, useEffect } from 'react';
import '../../../entrydoor.css';

const OPTIONS = [
  { value: 'None',    label: 'None'    },
  { value: '5/8"',   label: '5/8"'   },
  { value: '1"',     label: '1"'     },
  { value: '1 5/8"', label: '1 5/8"' },
  { value: '2"',     label: '2"'     },
];

// Values that make OverrideExtension visible
const OVERRIDE_VISIBLE = ['1"', '1 5/8"', '2"'];

const FrameExtension = ({ value = { value: '', label: '' }, onChange, disabled = false, onOverrideVisible }) => {
  const [selected, setSelected] = useState(value?.value || '');

  useEffect(() => { setSelected(value?.value || ''); }, [value?.value]);

  const handleChange = (e) => {
    const v = e.target.value;
    const label = OPTIONS.find(o => o.value === v)?.label || v;
    setSelected(v);
    onChange({ value: v, label });
    // notify panel whether OverrideExtension should be shown
    onOverrideVisible?.(OVERRIDE_VISIBLE.includes(v));
  };

  return (
    <div className="a-container">
      <label htmlFor="SdFrameExtension">Frame Extension</label>
      <select id="SdFrameExtension" value={selected} onChange={handleChange} disabled={disabled}>
        {OPTIONS.map(o => (
          <option key={o.value} value={o.value}>
            {selected === o.value ? `${o.label} ✔` : o.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default FrameExtension;
